import { Route, Routes } from "react-router-dom";
import Login from "./Login/Login";
import "./Auth.scss";

function Auth(props) {
  return (
    <div className="auth-main barn-light">
      <div className="auth-box">
        <Routes>
          <Route exact path="/admin" element={<Login {...props} />} />
        </Routes>
      </div>
    </div>
  );
}

export default Auth;
